import React from 'react';
import { withRouter } from 'react-router-dom';
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import { ACCESS_TOKEN_NAME } from '../constants/apiContants';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import LoadingOverlay from 'react-loading-overlay';
import store from "../store/index";
import i18n from '../i18n';
import axios from 'axios';
import { API_MOSA_URL } from '../constants/apiContants';
import ImageGallery from 'react-image-gallery';
import "./templatemo-style.css";
import pool from "../img/pool.JPG";
import track from "../img/track.JPG";
import football from "../img/football.JPG";
import gym from "../img/gym.JPG";
import stad from "../img/stad.JPG";
import logo from "../img/logo1.png";

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const images = [
    {
        original: require('../img/gym.JPG'),
        thumbnail: require('../img/gym.JPG'),
    },
    {
        original: require('../img/stad.JPG'),
        thumbnail: require('../img/stad.JPG'),
    },
    {
        original: require('../img/pool.JPG'),
        thumbnail: require('../img/pool.JPG'),
    },
];

const devicedetails = {
    "imei": "862188038288320",
    "deviceOSVersion": "6.0.1",
    "uuid": "862188038288320",
    "deviceModel": "NOKIA 100",
    "deviceManufacturer": "Xiaomi",
    "serviceProvider": "airtel",
    "deviceOS": "ANDROID",
    "ipAddress": "192.168.43.210"
}
const headers = {
    "RequestMode": "0",
    "UserID": localStorage.getItem('userid'),
    "BearerKey": "Mobile",
    "ServiceId": "SERV!",
    "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
    "Locale": "E/A",
    "DeviceDet": devicedetails

}
class Welcome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isActive: true,
            mTypes: [],
            lang: 'en',
        };

    }

    notify = (e) => {
        e.preventDefault();
        let self = this;
        if (!localStorage.getItem(ACCESS_TOKEN_NAME)) {
            Swal.fire({
                text: "Please logn first to continue",
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.props.history.push('/login');
                }
            })
        } else {
            if (localStorage.getItem("usertype") === "User") {
                this.props.history.push('/membership');
            } else {
                this.props.history.push({
                    pathname: '/createevent', state: {
                        locationid: 'WDKGN-9818-19',
                        stadiumid: 'ISOZL-195-17'
                    }
                });
            }

        }
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        // setTimeout(
        //     () => this.setState({ isActive: false }),
        //     1500
        // );
        headers.lang = this.state.lang;
        const mosa = { ReqHead: headers }
        let self = this;
        this.setState({ isActive: true })
        axios.post(API_MOSA_URL + '/User/Get360Images', mosa)

            .then(function (response) {
                console.log(JSON.stringify(response.data[1]));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {

                    if (response.data[0].StatusCode == "0") {

                        self.setState({ mTypes: response.data[1] });
                        //window.scrollTo(0, 0);

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });
    }

    venueDetails = (e, purl) => {
        this.props.history.push({
            pathname: '/home',
            state: { url: purl }
        });

    }

    render() {
        let self = this;
        store.subscribe(() => {
            console.log('change lang' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });

        let mtypes = this.state.mTypes;
        let mtItems = mtypes.map((mtype) =>
            <div className="card border" style={{ margin: "1px", maxWidth: '250px', height: '250px' }}>
                <div className="card-body">
                    <img src={logo} alt="image" style={{ maxWidth: '100px' }} className="img-responsive" />
                        <h4 style={{ fontFamily: 'Tajawal' }}>{this.state.lang=='ar' && mtype.facility_name_ar}{this.state.lang=='en' && mtype.facility_name_en}</h4>
                </div>
                <div className="card-footer">
                    <button onClick={e => this.venueDetails(e, mtype.url)} className="btn btn-light btn-radius btn-brd grd1"><span style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK230', this.state.lang)}</span></button>
                </div>
            </div>
        );

        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >
                <div style={{ backgroundColor: '#dfe6e9' }}>
                    {/* Modal */}
                    <div className="modal fade" id="login" tabIndex={-1} role="dialog" aria-labelledby="myModalLabel">
                        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header tit-up">
                                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                                    <h4 className="modal-title">Customer Login</h4>
                                </div>
                                <div className="modal-body customer-box">
                                    {/* Nav tabs */}
                                    <ul className="nav nav-tabs">
                                        <li><a className="active" href="#Login" data-toggle="tab">Login</a></li>
                                        <li><a href="#Registration" data-toggle="tab">Registration</a></li>
                                    </ul>
                                    {/* Tab panes */}
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="Login">
                                            <form role="form" className="form-horizontal">
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <input className="form-control" id="email1" placeholder="Name" type="text" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <input className="form-control" id="exampleInputPassword1" placeholder="Email" type="email" />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-10">
                                                        <button type="submit" className="btn btn-light btn-radius btn-brd grd1">
                                                            Submit
                                                    </button>
                                                        <a className="for-pwd" href="javascript:;">Forgot your password?</a>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="tab-pane" id="Registration">
                                            <form role="form" className="form-horizontal">
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <input className="form-control" placeholder="Name" type="text" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <input className="form-control" id="email" placeholder="Email" type="email" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <input className="form-control" id="mobile" placeholder="Mobile" type="email" />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <input className="form-control" id="password" placeholder="Password" type="password" />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-10">
                                                        <button type="button" className="btn btn-light btn-radius btn-brd grd1">
                                                            Save &amp; Continue
                                                        </button>
                                                        <button type="button" className="btn btn-light btn-radius btn-brd grd1">
                                                            Cancel</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Start header */}

                    <Navbar page={1} />
                    {/* End header */}
                    <div id="carouselExampleControls" className="carousel slide bs-slider box-slider" data-ride="carousel" data-pause="hover" data-interval="false">
                        {/* Indicators */}
                        <ol className="carousel-indicators">
                            <li data-target="#carouselExampleControls" data-slide-to={0} className="active" />
                            <li data-target="#carouselExampleControls" data-slide-to={1} />
                            <li data-target="#carouselExampleControls" data-slide-to={2} />
                        </ol>
                        <div className="carousel-inner" role="listbox" >
                            <div className="carousel-item active" style={{}}>
                                <div id="home" className="first-section" style={{ backgroundImage: `url(${pool})` }}>
                                    <div className="dtab">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 text-center">
                                                    <div className="big-tagline">
                                                        <h2 data-animation="animated zoomInRight" style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK200', this.state.lang)}
                                                        </h2>
                                                        <p className="lead" data-animation="animated fadeInLeft"></p>
                                                        <a href="#" className="hover-btn-new" onClick={e => this.notify(e)}><span style={{ fontFamily: 'Tajawal' }}>{i18n.t('DS8', this.state.lang)}</span></a>
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                </div>
                                            </div>{/* end row */}
                                        </div>{/* end container */}
                                    </div>
                                </div>{/* end section */}
                            </div>
                            <div className="carousel-item">
                                <div id="home" className="first-section" style={{ backgroundImage: `url(${track})` }}>
                                    <div className="dtab">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 text-center">
                                                    <div className="big-tagline">
                                                        <h2 data-animation="animated zoomInRight" style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK200', this.state.lang)}
                                                        </h2>
                                                        <p className="lead" data-animation="animated fadeInLeft"></p>
                                                        <a href="#" className="hover-btn-new" onClick={e => this.notify(e)}><span style={{ fontFamily: 'Tajawal' }}>{i18n.t('DS8', this.state.lang)}</span></a>
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                </div>
                                            </div>{/* end row */}
                                        </div>{/* end container */}
                                    </div>
                                </div>{/* end section */}
                            </div>
                            <div className="carousel-item">
                                <div id="home" className="first-section" style={{ backgroundImage: `url(${football})` }}>
                                    <div className="dtab">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12 col-sm-12 text-center">
                                                    <div className="big-tagline">
                                                        <h2 data-animation="animated zoomInRight" style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK200', this.state.lang)}
                                                        </h2>
                                                        <p className="lead" data-animation="animated fadeInLeft"></p>
                                                        <a href="#" className="hover-btn-new" onClick={e => this.notify(e)}><span style={{ fontFamily: 'Tajawal' }}>{i18n.t('DS8', this.state.lang)}</span></a>
                                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </div>
                                                </div>
                                            </div>{/* end row */}
                                        </div>{/* end container */}
                                    </div>
                                </div>{/* end section */}
                            </div>
                            {/* Left Control */}
                            <a className="new-effect carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                <span className="fa fa-angle-left" aria-hidden="true" />
                                <span className="sr-only">{i18n.t('DS5', this.state.lang)}</span>
                            </a>
                            {/* Right Control */}
                            <a className="new-effect carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                <span className="fa fa-angle-right" aria-hidden="true" />
                                <span className="sr-only">{i18n.t('DS6', this.state.lang)}</span>
                            </a>
                        </div>
                    </div>
                    <div id="overviews" className="section wb  wow fadeIn" style={{ backgroundColor: '#dfe6e9' }}>
                        <div className="container">
                            {/* end title */}
                            <div className="row align-items-center border" style={{ backgroundColor: 'white' }}>
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <div className="message-box ">
                                        <h4 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK15', this.state.lang)}</h4>
                                        <h2 style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK14', this.state.lang)}</h2>
                                        <p style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK16', this.state.lang)}</p>
                                        <p style={{ fontFamily: 'Tajawal', display: 'none' }}>{i18n.t('JK17', this.state.lang)} </p>
                                        {localStorage.getItem("usertype") === "User" &&
                                            <button onClick={e => this.notify(e)} className="btn btn-light btn-radius btn-brd grd1"><span>{i18n.t('DS7', this.state.lang)}</span></button>
                                        }
                                        {localStorage.getItem("usertype") !== "User" &&
                                            <button onClick={e => this.notify(e)} className="btn btn-light btn-radius btn-brd grd1"><span>{i18n.t('DS8', this.state.lang)}</span></button>
                                        }
                                    </div>{/* end messagebox */}
                                </div>{/* end col */}
                                <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 hidesmall">
                                    <div className="post-media">
                                        <ImageGallery items={images} autoPlay={true} showFullscreenButton={false} style={{ maxHeight: '500px', maxWidth: '500px' }} />
                                        {/* <img style={{ maxHeight: '500px', maxWidth: '500px' }} src={stad}></img> */}
                                    </div>{/* end media */}
                                </div>{/* end col */}
                            </div>
                        </div>{/* end container */}
                    </div>{/* end section */}

                    {/* <div id="overviews" className="section wb">
                    <div className="container">
                        <hr className="hr3" />
                        <div className="row">
                            {[...Array(3)].map((x, i) =>


                                <div key={i} className="col-lg-4 col-md-6 col-12">
                                    <div className="blog-item">
                                        <div className="image-blog">
                                            <img src="images/blog_1.jpg" alt="" className="img-fluid" />
                                        </div>
                                        <div className="meta-info-blog">
                                            <span><i className="fa fa-calendar" /> <a href="#">May 11, 2015</a> </span>
                                            <span><i className="fa fa-tag" />  <a href="#">News</a> </span>
                                            <span><i className="fa fa-comments" /> <a href="#">12 Comments</a></span>
                                        </div>
                                        <div className="blog-title">
                                            <h2><a href="#" title>perferendis doloribus asperiores.</a></h2>
                                        </div>
                                        <div className="blog-desc">
                                            <p>Lorem ipsum door sit amet, fugiat deicata avise id cum, no quo maiorum intel ogrets geuiat operts elicata libere avisse id cumlegebat, liber regione eu sit.... </p>
                                        </div>
                                        <div className="blog-button">
                                            <a className="hover-btn-new orange" href="#"><span>Read More<span /></span></a>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div> */}

                    <section className="container">
                        <div className="text-center">
                            <div className="row" style={{ width: '100%', color: 'grey' }}>
                                <div className="col-lg-4 col-md-3 col-sm-3 text-center  hidesmall"><hr /></div>
                                <div className="col-lg-4 col-md-6 col-sm-6 text-center "><h2 className="" style={{ color: 'grey !important', fontFamily: 'Tajawal' }}>{i18n.t('JK201', this.state.lang)}</h2></div>
                                <div className="col-lg-4 col-md-3 col-sm-3 text-center  hidesmall"><hr /></div>
                            </div>
                        </div>
                    </section>

                    <div className="container wow slideInLeft" style={{}}>
                        <div>
                            <div style={{ height: '100%', padding: '10px', textAlign: 'center' }}>
                                <Carousel
                                    responsive={responsive}
                                    swipeable={false}
                                    autoPlay={true}
                                    ssr={true}
                                    infinite={true}
                                    autoPlaySpeed={3000}>


                                    {mtItems}

                                </Carousel>
                            </div>
                        </div>
                    </div>

                    <br />


                    <Footer />
                    <a href="#" id="scroll-to-top" className="dmtop global-radius"><i className="fa fa-angle-up" /></a>
                </div>
            </LoadingOverlay>

        )
    }
}
export default withRouter(Welcome);
